import App from "./app";
import ReactDOM from "react-dom";

ReactDOM.render(<App />, document.getElementById("root"));
